import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import queryString from 'query-string';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import Pager from 'admin/components/shared/Pager';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import { toQueryParams, formatDate } from 'admin/utils';
import { getKioskHealths } from 'admin/actions/devices';
import styles from './styles.scss';

class KioskHealth extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 20 };
    this.params = queryString.parse(this.props.location.search);
  }

  componentDidMount() {
    this.fetchKioskHealths();
  }

  onChangePage = (page) => {
    this.fetchKioskHealths({ page });
  }

  fetchKioskHealths(pagination) {
    const pageParams = Object.assign({}, this.defaultPagination, pagination);
    const params = Object.assign({}, pageParams, { kiosk_id: this.params.kiosk_id });
    this.props.getKioskHealths(toQueryParams(params, true));
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス管理', href: '/settings/devices', active: false },
      { value: 'ヘルス履歴', href: '/', active: true },
    ];
    const columns = [
      { label: '更新日時', align: 'center', size: 2 },
      { label: '作成日時', align: 'center', size: 2 },
      { label: 'コインメック', align: 'center', size: 1 },
      { label: 'ビルバリ', align: 'center', size: 1 },
      { label: 'プリンタ', align: 'center', size: 1 },
      { label: 'エスクロ', align: 'center', size: 1 },
      { label: '前扉', align: 'center', size: 1 },
      { label: 'CAT', align: 'center', size: 1 },
      { label: 'UPS', align: 'center', size: 1 },
      { label: 'App Version', align: 'center', size: 1 },
      { label: 'Browser Location', align: 'center', size: 1 },
    ];
    const rows = this.props.kioskHealths.rows.map(kioskHealth => [
      { data: (<span>{formatDate(kioskHealth.updated_at)}</span>), align: 'center' },
      { data: (<span>{formatDate(kioskHealth.created_at)}</span>), align: 'center' },
      { data: (<span>{kioskHealth.coinmech}</span>), align: 'center' },
      { data: (<span>{kioskHealth.bill_validator}</span>), align: 'center' },
      { data: (<span>{kioskHealth.printer}</span>), align: 'center' },
      { data: (<span>{kioskHealth.escrow}</span>), align: 'center' },
      { data: (<span>{kioskHealth.front_door}</span>), align: 'center' },
      { data: (<span>{kioskHealth.cat}</span>), align: 'center' },
      { data: (<span>{kioskHealth.ups}</span>), align: 'center' },
      { data: (<span>{kioskHealth.app_version}</span>), align: 'center' },
      { data: (<span>{kioskHealth.browser_location}</span>), align: 'center' },
    ]);
    return (
      <div>
        <Breadcrumb items={crumb} />
        <div styleName="headline">端末ID：{this.params.kiosk_id}　端末名：{this.params.kiosk_name}</div>
        <div styleName="list-table">
          <TableHeader columns={columns} />
          <TableRows rows={rows} columns={columns} />
        </div>
        <Pager
          pagination={this.props.kioskHealths.pagination}
          onChangePage={this.onChangePage}
        />
      </div>
    );
  }
}

KioskHealth.defaultProps = {
  kioskHealths: { rows: [], pagination: {} },
  getKioskHealths: PropTypes.func,
};

KioskHealth.propTypes = {
  getKioskHealths: PropTypes.func,
  kioskHealths: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      updated_at: PropTypes.string,
      created_at: PropTypes.string,
      coinmech: PropTypes.string,
      coinmech_message: PropTypes.string,
      bill_validator: PropTypes.string,
      bill_validator_message: PropTypes.string,
      printer: PropTypes.string,
      printer_message: PropTypes.string,
      escrow: PropTypes.string,
      escrow_message: PropTypes.string,
      front_door: PropTypes.string,
      front_door_message: PropTypes.string,
      cat: PropTypes.string,
      cat_message: PropTypes.string,
      ups: PropTypes.string,
      ups_message: PropTypes.string,
      app_version: PropTypes.string,
      browser_location: PropTypes.string,
    })),
    pagination: PropTypes.shape({
      has_next: PropTypes.bool,
      has_prev: PropTypes.bool,
      max_page: PropTypes.number,
      per_page: PropTypes.number,
      current: PropTypes.number,
    }),
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  kioskHealths: state.device.kioskHealths,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getKioskHealths,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(KioskHealth, styles));
